import React from 'react'
import './style.scss'

type MainProps = {
  pageTitle: string
  children?: React.ReactNode
}

const Main: React.FC<MainProps> = (props) => {
  const { pageTitle, children } = props
  return (
    <main className='main'>
      <div className='container-wrap'>
        <h2 className='title'>
          {pageTitle}
        </h2>
        {children}
      </div>
    </main>
  );
}

export default Main;
